/**
 * Constants for the EAS (Email Acquisition Service) forms
 */

// ============================================================================
// STORAGE KEYS
// ============================================================================

export const STORAGE_KEYS = {
  LAST_USED_EMAIL: 'eas_last_used_email',
} as const;

// ============================================================================
// COLORS
// ============================================================================

export const COLORS = {
  ERROR: '#df000d',
  SUCCESS: '#2e7d32',
  PRIMARY_TEXT: '#363a41',
  FIELD_BORDER: '#d9d9d9',
  SELECT_HOVER: '#eeeef6', // lavender
  SELECTED_INDICATOR: '#2563eb', // left border
} as const;

// ============================================================================
// TYPOGRAPHY
// ============================================================================

export const TYPOGRAPHY = {
  FONT_FAMILY:
    'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  LETTER_SPACING: '0px',
} as const;

// ============================================================================
// APP TYPES
// ============================================================================

export const APP_TYPES = {
  FORM: 'form',
  MODAL: 'modal',
} as const;
